import { render, staticRenderFns } from "./index_latihan_kecermatan.vue?vue&type=template&id=aaf36022&"
import script from "./index_latihan_kecermatan.vue?vue&type=script&lang=js&"
export * from "./index_latihan_kecermatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports